import { compile } from 'path-to-regexp';

export enum ApiRoutes {
  USERS_REGISTER = '/users/register',
  USERS_VERIFICATION_EMAIL = '/users/verification-email',
}

export enum PageRoutes {
  HOME = '/',
  LOGIN = '/login',
  SIGNUP = '/signup',
  REGISTER_SUCCESS = '/signup/thank-you',
  INVITATION = '/invitation',
  AUTHORISATION_ERROR = '/authorisation-error',
  NOT_FOUND = '/404',
}

export const pathToUrl = (path: string, params: object = {}) =>
  compile(path)(params);
